import Vue from 'vue';

/**
 * @author Duke
 *
 */
import zhDialog from './src/zhdialog.vue';

zhDialog.install = function (Vue) {
  Vue.component(zhDialog.name, zhDialog);
};

export default zhDialog;



// WEBPACK FOOTER //
// ./ui/zhdialog/index.js